import { useContext } from 'react';
import {
  useFlutterwave as FlutterPay,
  closePaymentModal,
} from 'flutterwave-react-v3';
import FormContext from '../../contexts/form/formContext';
import { v4 } from 'uuid';

const FLW_KEY = process.env.REACT_APP_FLW_KEY;

const FlwBtnComp = ({ code }) => {
  const {
    payObj: { amount, name, email, phone, msg, schoolName },
  } = useContext(FormContext);

  const config = {
    public_key: FLW_KEY,
    tx_ref: v4(),
    amount,
    currency: 'NGN',
    payment_options: 'card',
    redirect_url: `${window.location.origin}/paid/${name}`,
    customer: {
      email: email,
      phone_number: phone,
      name,
    },
    meta: {
      code,
      amount,
      schoolName,
    },
    customizations: {
      title: 'NATIONAL DIGITAL LITERACY COMPETITION 2022 REGISTRATION FORM',
      description: `payment for registration`,
      logo: 'https://ershemug.sirv.com/100pay/download%20(1).png',
    },
  };

  const handleFlutterPayment = FlutterPay(config);

  const payNowFunc = () => {
    if (msg !== 'not found') {
      handleFlutterPayment({
        callback: (response) => {
          console.log(response);
          closePaymentModal(); // this will close the modal programmatically
        },
        onClose: () => {},
      });
    }
  };

  return (
    <button
      className="py-2 px-10 rounded-lg bg-amber-300 my-4"
      onClick={payNowFunc}
    >
      pay now
    </button>
  );
};

const FlwTxtComp = ({ code }) => {
  const {
    payObj: { amount, name, email, phone, msg, schoolName },
  } = useContext(FormContext);
  const config = {
    public_key: FLW_KEY,
    tx_ref: v4(),
    amount,
    currency: 'NGN',
    payment_options: 'card',
    redirect_url: `${window.location.origin}/paid/${name}`,
    customer: {
      email: email,
      phone_number: phone,
      name,
    },
    meta: {
      code,
      amount,
      schoolName,
    },
    customizations: {
      title: 'NATIONAL DIGITAL LITERACY COMPETITION 2022 REGISTRATION FORM',
      description: `payment for registration`,
      logo: 'https://ershemug.sirv.com/100pay/download%20(1).png',
    },
  };

  const handleFlutterPayment = FlutterPay(config);

  const payNowFunc = () => {
    if (msg !== 'not found') {
      handleFlutterPayment({
        callback: (response) => {
          console.log(response);
          closePaymentModal(); // this will close the modal programmatically
        },
        onClose: () => {},
      });
    }
  };

  return (
    <span
      className="text-blue-600 cursor-pointer font-medium text-lg"
      onClick={payNowFunc}
    >
      here
    </span>
  );
};

export { FlwBtnComp, FlwTxtComp };
